var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',[_c('header-component'),_vm._v(" "),_c('main',{style:({'flex-direction': _vm.$screen.breakpoint !=='sm' ? 'row' : 'column', 'overflow-y': _vm.$screen.breakpoint !== 'lg' ? 'scroll' : 'hidden'})},[_c('nav-scroller-component'),_vm._v(" "),_c('info-component')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-199b0b90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/api/APIDocs.vue
// module id = 661
// module chunks = 1